<template>
  <div class="text-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="视频封面"
          name="2"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
            <!-- <div class="data-source-type">
              <el-radio v-model="noCacheComponent" :label="labelFalse">无</el-radio>
              <el-radio v-model="noCacheComponent" :label="labelTrue">自定义</el-radio>
            </div> -->
            <div class="img_up content flex">
              <img-upload :imgSrc.sync="uploadVideoImg" imgType="12" :defaultImg="defaultImgBg"></img-upload>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="播放按钮"
          name="3"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
            <div class="verticallyCenter">
              <div class="fs14 mr16 w56">尺寸</div>
              <single-input
                class="mr8"
                style="width: 74px"
                :value.sync="iconWidth"
                inputSuffixs="宽"
              />
              <single-input
                style="width: 74px"
                :value.sync="iconHeight"
                inputSuffixs="高"
              />
            </div>
            <div class="mt16 verticallyCenter">
              <span class="mr16">图标颜色</span>
              <!-- <color-picker class="" :color.sync="iconColor" title="图标颜色"></color-picker> -->
              <!-- <color-picker-theme-color class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :color.sync="iconColor"></color-picker-theme-color> -->
              <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
              </cx-color-picker>
            </div>
            <div class="mt16 verticallyCenter">
              <span class="mr16">图标背景</span>
              <!-- <color-picker class="" :color.sync="bgColor" title="图标背景"></color-picker> -->
              <!-- <color-picker-theme-color class="flex1" :isThemeColor.sync="iconBgIsThemeColor" :color.sync="bgColor"></color-picker-theme-color> -->
              <cx-color-picker class="flex1 w-156" :isThemeColor.sync="iconBgIsThemeColor" :colorArr.sync="bgColor">
              </cx-color-picker>
            </div>
            <div class="mt16">
              <div class="fs14 mb8">圆角</div>
              <slider-and-input
                inputWidth="large"
                inputHeight="large"
                :value.sync="iconRadius"
                title=""
                :sliderMax="100"
                suffix="px"
              />
            </div>
            <div class="select-input-container mt16">
              <cx-border
                :borderWidth.sync="iconBorderWidth"
                :borderStyle.sync="iconBorderStyle"
                :borderColor.sync="iconBorderColor"
                :borderIsThemeColor.sync="iconBorderIsThemeColor"
              />
              <!-- <line-setting title="边框" :lineName.sync="iconBorderStyle" :lineWidth.sync="iconBorderWidth" /> -->
              <!-- <color-picker class="video-border-color" :color.sync="iconBorderColor" title=""></color-picker> -->
              <!-- <cx-color-picker class="video-border-color" :isThemeColor="false" :colorArr.sync="iconBorderColor">
              </cx-color-picker> -->
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="播放设置"
          name="4"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
            <div class="dialog-play-setting">
              <span class="mr16">播放位置</span>
              <div class="data-source-type">
                <div v-if="!ids.uid"><el-radio v-model="dialogPlay" :label="labelFalse">弹框播放</el-radio></div>
                <div><el-radio v-model="dialogPlay" :label="labelTrue">原位播放</el-radio></div>
              </div>
            </div>
            <div class="mt16 dialog-play-mode">
              <span class="mr16">播放方式</span>
              <div class="data-source-type">
                <cx-check-box :value.sync="loopPlay">循环播放</cx-check-box>
                <cx-check-box :value.sync="controlStatus">显示控制条</cx-check-box>
                <cx-check-box :value.sync="autoplayStatus">自动播放</cx-check-box>
                <cx-check-box :value.sync="muted">静音</cx-check-box>
              </div>
            </div>
          </div>
          <!-- <big-screen-animate-set></big-screen-animate-set> -->
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="外观" name="5">
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
            <slider-and-input
              class=""
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <div class="content-item mt16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                :sliderMax="paddingMax"
              />
            </div>
            <div class="mt16">
              <div class="mb16">边框</div>
              <cx-border
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')" title="边距" name="7">
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')">
            <cx-padding
              :paddingTypeFlag.sync="videoPaddingTypeFlag"
              :padding.sync="videolegendPadding"
              :paddingTop.sync="videoPaddingTop"
              :paddingRight.sync="videoPaddingRight"
              :paddingBottom.sync="videoPaddingBottom"
              :paddingLeft.sync="videoPaddingLeft"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="8">
          <div class="setting-item">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import defaultImgBg from "assets/images/empty_img_bg.png"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "video-options-data",
  components: {
    TextSettingComplex,
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "8"],
      allCollapseNames: ["4", "5", "6", "7"],
      collapseActiveNames: ["1", "2", "3", "8"],
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      defaultImgBg: defaultImgBg,
      labelTrue: true,
      labelFalse: false,
      // 边距设置
      videoPaddingTypeFlag: 1,
      this1: this
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    uploadVideoImg: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "uploadVideoImg", "uploadVideoImg", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "uploadVideoImg", false)
      }
    },
    // 边框样式
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    iconBorderStyle: {
      get() {
        return this.options.iconBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBorderStyle", false)
      }
    },
    iconBorderWidth: {
      get() {
        return this.options.iconBorderWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBorderWidth", false)
      }
    },
    iconBorderIsThemeColor: {
      get() {
        return this.options.iconBorderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBorderIsThemeColor", false)
      }
    },
    iconRadius: {
      get() {
        return this.options.hasOwnProperty("iconRadius") ? this.options.iconRadius : parseInt(this.iconWidth / 2)
      },
      set(newVal) {
        this.$changeOptionsEV(Number(newVal), "iconRadius", false)
      }
    },
    iconBorderColor: {
      get() {
        return this.options.iconBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBorderColor", false)
      }
    },
    // 弹框原位播放
    dialogPlay: {
      get() {
        return this.options.dialogPlay
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogPlay", false)
      }
    },
    // 循环播放
    loopPlay: {
      get() {
        return this.options.loopPlay
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loopPlay", false)
      }
    },
    // 自动播放
    autoplayStatus: {
      get() {
        return this.options.autoplayStatus
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "muted", false)
        this.$changeOptionsEV(newVal, "autoplayStatus", false)
      }
    },
    // 静音
    muted: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "muted", "muted", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "muted", false)
      }
    },
    // 显示控制条
    controlStatus: {
      get() {
        return this.options.controlStatus
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "controlStatus", false)
      }
    },
    // 边距
    videolegendPadding: {
      get() {
        return this.options.videolegendPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videolegendPadding", false)
      }
    },
    videoPaddingTop: {
      get() {
        return this.options.videoPaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoPaddingTop", false)
      }
    },
    videoPaddingRight: {
      get() {
        return this.options.videoPaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoPaddingRight", false)
      }
    },
    videoPaddingLeft: {
      get() {
        return this.options.videoPaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoPaddingLeft", false)
      }
    },
    videoPaddingBottom: {
      get() {
        return this.options.videoPaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoPaddingBottom", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    // rotate: {
    //   get() {
    //     return parseInt(this.options.rotate)
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal + "deg", "rotate", false)
    //   }
    // },

    iconColor: {
      get() {
        return this.options.iconColor || "#fff"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconHeight", "iconHeight", 42)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconHeight", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconColorIsThemeColor", "iconColorIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    iconBgIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconBgIsThemeColor", "iconBgIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBgIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    opacity: {
      get() {
        return this.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
  },
  methods: {
    changeVideoPaddingType(value) {
      this.videoPaddingTypeFlag = value
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    }
  }
})
</script>

<style scoped>
.el-radio {
  margin-right: 20px;
  margin-bottom: 0px !important;
}
.el-radio:nth-child(2n) {
  margin-right: 0;
}

.video-start-btn-setting {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.flex_box {
  display: flex;
  align-items: center;
}

.data-source-type .bigScreen .toolbar .el-radio__label {
  margin-left: 0px;
}
.dialog-play-mode > span {
  display: inline-block;
  vertical-align: top;
}

.dialog-play-mode .data-source-type {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 72px);
}

.video-border-setting > div:first-child {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 40px);
}
.video-border-color {
  display: inline-block;
  vertical-align: bottom;
  width: 32px;
  margin-left: 8px;
}
.video-border-color ::v-deep .text_color_in_input {
  display: none;
}
.bigScreen .toolbar .dialog-play-setting ::v-deep .el-radio__label {
  margin-left: 0;
}

.boxshadow-wrap {
  z-index: 9999;
}
.toolbar .dialog-play-setting {
  display: flex;
  color: var(--textColor);
}
.dialog-play-setting ::v-deep .el-radio__label {
  color: var(--textColor);
}
.w-156 {
  width: 156px;
}
.video-border-color ::v-deep .right-handle-icon,
.video-border-color ::v-deep .color-text {
  display: none !important;
}
</style>
